import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface WhatsappIconPropTypes {
  height?: number;
  width?: number;
}

const WhatsappIcon = (props: WhatsappIconPropTypes) => {
  const { height, width } = props;
  return (
    <SVGUniqueID>
      <svg
        width={width ? width : 32}
        height={height ? height : 32}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
        viewBox="0 0 32 32"
        {...props}
      >
        <path
          d="m2.368 29.39 1.907-6.947A13.364 13.364 0 0 1 2.48 15.74C2.484 8.348 8.51 2.333 15.919 2.333a13.367 13.367 0 0 1 9.505 3.933 13.314 13.314 0 0 1 3.932 9.485c-.003 7.392-6.032 13.408-13.438 13.408 0 0 .001 0 0 0h-.005a13.45 13.45 0 0 1-6.421-1.633l-7.124 1.865Z"
          fill="#E2E8F0"
        />
        <path
          d="M15.923 4.598c-6.161 0-11.171 4.999-11.173 11.143a11.1 11.1 0 0 0 1.707 5.93l.266.422-1.129 4.112L9.821 25.1l.408.241a11.168 11.168 0 0 0 5.685 1.554h.004c6.156 0 11.166-5 11.169-11.144a11.064 11.064 0 0 0-3.268-7.884 11.107 11.107 0 0 0-7.896-3.268Z"
          fill="url(#c)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.56 10.136c-.252-.558-.517-.57-.756-.58-.195-.008-.42-.007-.643-.007-.224 0-.588.084-.895.42-.308.334-1.176 1.145-1.176 2.794s1.204 3.242 1.371 3.466c.168.223 2.323 3.715 5.736 5.058 2.836 1.116 3.413.894 4.029.838.616-.055 1.986-.81 2.266-1.593.28-.782.28-1.453.196-1.593-.084-.14-.308-.223-.644-.391-.335-.167-1.986-.978-2.294-1.09-.308-.112-.532-.168-.756.168-.223.335-.866 1.09-1.062 1.313-.196.224-.392.252-.728.084-.336-.168-1.417-.521-2.7-1.663-.998-.888-1.672-1.985-1.868-2.32-.196-.336-.02-.517.148-.684.15-.15.335-.392.503-.587.168-.196.224-.335.336-.559.112-.224.056-.42-.028-.587-.084-.167-.737-1.825-1.035-2.487Z"
          fill="#FEFEFE"
        />
        <defs>
          <linearGradient
            id="c"
            x1={15.691}
            y1={5.936}
            x2={15.804}
            y2={24.989}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#57D163" />
            <stop offset={1} stopColor="#23B33A" />
          </linearGradient>
        </defs>
      </svg>
    </SVGUniqueID>
  );
};

export { WhatsappIcon };
